import React, { useEffect } from 'react';
import { Collapse, Alert, Spin } from 'antd';
import { BranchesOutlined } from '@ant-design/icons';
import ModuleGroupPreview from '../../module-group/ModuleGroupPreview';
import useModuleGroupStore from '../../../stores/useModuleGroupStore';

const CampaignFlowSection = ({ moduleGroupId, campaignState, defaultExpanded, flowSnapshot, moduleResponseOverrides, noSlotsMessage }) => {
    const { moduleGroup, loading } = useModuleGroupStore();

    useEffect(() => {
        // Only fetch live module group if no snapshot is available
        if (moduleGroupId && !flowSnapshot) {
            useModuleGroupStore.getState().fetchModuleGroup(moduleGroupId);
        }
    }, [moduleGroupId, flowSnapshot]);

    const flowName = flowSnapshot?.name || moduleGroup?.name || '';

    let warningMessage;
    let warningType = 'info';
    if (flowSnapshot) {
        warningMessage = 'This is the flow as configured when the campaign was scheduled.';
    } else if (campaignState === 'scheduled') {
        warningMessage = 'This is the current flow. It may be modified before the campaign sends.';
    } else {
        warningMessage = 'This flow is shown in its current state and may have changed since this campaign was sent.';
        warningType = 'warning';
    }

    return (
        <div style={{
            background: '#fff',
            border: '1px solid var(--gh-gray-200, #E6E6E6)',
            borderRadius: 8
        }}>
            <Collapse
                defaultActiveKey={defaultExpanded ? ['flow'] : []}
                ghost
                items={[{
                    key: 'flow',
                    label: (
                        <span style={{ fontWeight: 500, fontSize: 13 }}>
                            <BranchesOutlined style={{ marginRight: 6 }} />
                            Automated Conversation: {flowName || 'Loading...'}
                        </span>
                    ),
                    children: (
                        <>
                            <Alert
                                type={warningType}
                                showIcon
                                style={{ marginBottom: 8 }}
                                message={warningMessage}
                            />
                            <div style={{ minHeight: 300 }}>
                                {!flowSnapshot && loading ? (
                                    <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>
                                ) : (
                                    <ModuleGroupPreview
                                        moduleGroupId={moduleGroupId}
                                        snapshotData={flowSnapshot}
                                        moduleResponseOverrides={moduleResponseOverrides}
                                        noSlotsMessage={noSlotsMessage}
                                    />
                                )}
                            </div>
                        </>
                    )
                }]}
            />
        </div>
    );
};

export default CampaignFlowSection;
